module.exports = __webpack_public_path__ + "static/29gde-72dd0a6269c01f2df376a8d2bdff75d3.gif";